<template>
  <div>
    <table
      v-if="!hideLinkControl1 && !hideLinkControl2"
      v-intersect.once
      class="my-release-list__table"
      @intersect="onIntersect">
      <thead class="my-release-list__thead">
        <tr>
          <th class="my-release-list__cell-jacket">ジャケット</th>
          <th class="my-release-list__cell-genre">リリース種別</th>
          <th class="my-release-list__cell-artist u-text-align-left">アーティスト名</th>
          <th class="my-release-list__cell-title u-text-align-left">タイトル</th>
          <th
            v-if="!hideControl3 && !hideStatus && !removeStatus"
            class="my-release-list__cell-status">
            ステータス
          </th>
          <th
            v-if="!hideControl3 && hideStatus"
            class="my-release-list__cell-status">
            {{ statusColumnTitle }}
          </th>
          <th
            v-if="!hideControl1 && !hideControl3"
            class="my-release-list__cell-delete wide">
            {{ controlText }}
          </th>
          <th
            v-if="!hideControl1 && hideControl3"
            class="my-release-list__cell-delete super-wide">
            {{ controlText }}
          </th>
          <th
            v-if="!hideControl2"
            class="my-release-list__cell-delete">
            削除
          </th>
        </tr>
      </thead>
      <tbody
        v-if="pagination.data && pagination.data.length > 0"
        class="my-release-list__tbody">
        <tr
          v-for="item in pagination.data"
          :key="item.id">
          <td>
            <div
              :class="[
                {'my-release-list__thumb--none':!item.coverart_filepath},
                'my-release-list__thumb']">
              <img
                v-if="item.coverart_filepath"
                :src="`/images/${item.coverart_filepath}`"
                alt="">
            </div>
          </td>
          <td>{{ item.type | toJapanese }}</td>
          <td class="u-text-align-left">{{ getMainArtists(item) }}</td>
          <td class="u-text-align-left wrap-text">{{ anyTitle(item) }}</td>
          <td v-if="!hideControl3 && !hideStatus && !removeStatus">
            {{ item.release_status_name }}
          </td>
          <td v-if="!hideControl3 && hideStatus">
            <slot
              name="statusReplacement"
              :release="item" />
          </td>
          <td v-if="!hideControl1 && !hideControl3">
            <slot
              name="control1"
              :release="item" />
          </td>
          <td v-if="!hideControl2">
            <slot
              name="control2"
              :release="item" />
          </td>
          <td v-if="!hideControl1 && hideControl3">
            <slot
              name="control3"
              :release="item" />
          </td>
        </tr>
      </tbody>
      <tbody
        v-else-if="loading"
        class="link-list__tbody">
        <tr>
          <td
            class="empty-cell vld-parent"
            :class="{ 'disabled-cell': loading }"
            :colspan="numberOfColumns">
            <div
              class="vld-cell">
              <div class="vld-loading-icon">
                <vue-loading
                  background-color="#fff"
                  :opacity="0"
                  :active="true"
                  :height="20"
                  :width="20"
                  :is-full-page="false">
                </vue-loading>
              </div>
              <div class="vld-text">
                読み込み中
              </div>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody
        v-else-if="!loading"
        class="my-release-list__tbody">
        <tr>
          <td
            class="empty-cell"
            :colspan="numberOfColumns">
            <slot name="empty" />
          </td>
        </tr>
      </tbody>
    </table>
    <table
      v-else
      v-intersect.once
      class="my-release-list__table"
      @intersect="onIntersect">
      <thead class="my-release-list__thead">
        <tr>
          <th class="link-list__cell-jacket">ジャケット</th>
          <th class="link-list__cell-genre">リリース種別</th>
          <th class="link-list__cell-artist u-text-align-left">アーティスト名</th>
          <th class="link-list__cell-title u-text-align-left">タイトル</th>
          <th
            v-if="!hideStatus"
            class="link-list__cell-status">
            ステータス
          </th>
          <th
            v-if="hideStatus"
            class="link-list__cell-status">
            {{ statusColumnTitle }}
          </th>
          <th class="link-list__cell-regist">登録<br>情報</th>
          <th class="link-list__cell-regist">Link<br>設定</th>
          <th class="link-list__cell-link-show">Link</th>
        </tr>
      </thead>
      <tbody
        v-if="pagination.data && pagination.data.length > 0"
        class="link-list__tbody">
        <tr
          v-for="item in pagination.data"
          :key="item.id">
          <td>
            <div
              :class="[
                {'link-list__thumb--none':!item.coverart_filepath},
                'link-list__thumb']">
              <img
                v-if="item.coverart_filepath"
                :src="`/images/${item.coverart_filepath}`"
                alt="">
            </div>
          </td>
          <td>{{ item.type | toJapanese }}</td>
          <td class="u-text-align-left">{{ getMainArtists(item) }}</td>
          <!-- eslint-disable vue/no-v-html -->
          <td
            class="u-text-align-left"
            v-html="anyTitle(item)">
          </td>
          <!-- eslint-enable vue/no-v-html -->
          <td v-if="!hideStatus">{{ item.release_status_name }}</td>
          <td v-if="hideStatus">
            <slot
              name="statusReplacement"
              :release="item" />
          </td>
          <td v-if="hideLinkControl1">
            <slot
              name="linkControl1"
              :release="item" />
          </td>
          <td v-if="hideLinkControl2">
            <slot
              name="linkControl2"
              :release="item" />
          </td>
          <td v-if="hideLinkControl3">
            <slot
              name="linkControl3"
              :release="item" />
          </td>
        </tr>
      </tbody>
      <tbody
        v-else-if="loading"
        class="link-list__tbody">
        <tr>
          <td
            class="empty-cell vld-parent"
            :class="{ 'disabled-cell': loading }"
            :colspan="numberOfColumns">
            <div
              class="vld-cell">
              <div class="vld-loading-icon">
                <vue-loading
                  background-color="#fff"
                  :opacity="0"
                  :active="true"
                  :height="20"
                  :width="20"
                  :is-full-page="false">
                </vue-loading>
              </div>
              <div class="vld-text">
                読み込み中
              </div>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody
        v-else-if="!loading"
        class="link-list__tbody">
        <tr>
          <td
            class="empty-cell"
            :colspan="numberOfColumns">
            <slot name="empty" />
          </td>
        </tr>
      </tbody>
    </table>
    <pagination
      v-if="!hideControl3"
      :pagination="pagination"
      @on-pagination-clicked="onPaginationClicked">
    </pagination>
  </div>
</template>

<script>

import VueLoading from 'vue-loading-overlay'
import Pagination from '../../../components/Pagination'
import {
  CMAP_RELEASE_STATUS_DRAFT,
  CMAP_RELEASE_STATUS_DSP_REJECTED,
  CMAP_RELEASE_STATUS_REJECTED,
} from '../../../consts/status'

export default {
  name: 'ReleaseTable',
  components: {
    Pagination,
    VueLoading,
  },
  filters: {
    toJapanese: (value) => (value === 'single' ? 'シングル' : 'アルバム'),
  },
  props: {
    releaseStatus: {
      type: [Number, String, Array],
      required: true,
    },
    hideControl1: {
      type: Boolean,
      default: false,
    },
    hideControl2: {
      type: Boolean,
      default: false,
    },
    hideControl3: {
      type: Boolean,
      default: false,
    },
    hideLinkControl1: {
      type: Boolean,
      default: false,
    },
    hideLinkControl2: {
      type: Boolean,
      default: false,
    },
    hideLinkControl3: {
      type: Boolean,
      default: false,
    },
    hideStatus: {
      type: Boolean,
      default: false,
    },
    removeStatus: {
      type: Boolean,
      default: false,
    },
    statusColumnTitle: {
      type: String,
      default: '',
    },
    keyword: {
      type: [Number, String],
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      pagination: {},
      timer: null,
      featuringPrefixes: {},
    }
  },
  computed: {
    numberOfColumns() {
      let totalColumns = 7
      if (this.hideControl1) {
        totalColumns -= 1
      }
      if (this.hideControl2) {
        totalColumns -= 1
      }
      if (this.hideControl3) {
        totalColumns -= 1
      }
      if (this.removeStatus) {
        totalColumns -= 1
      }
      if (this.hideLinkControl3) {
        totalColumns += 1
      }
      return totalColumns
    },
    isEditable() {
      const releaseStatus = Array.isArray(this.releaseStatus)
        ? this.releaseStatus
        : [this.releaseStatus]

      return releaseStatus.includes(CMAP_RELEASE_STATUS_DRAFT)
        || releaseStatus.includes(CMAP_RELEASE_STATUS_REJECTED)
        || releaseStatus.includes(CMAP_RELEASE_STATUS_DSP_REJECTED)
    },
    count() {
      if (this.hideControl3) {
        return 3
      }
      return 10
    },
    controlText() {
      if (this.isEditable && !this.hideControl3) {
        return '編集'
      }
      if (!this.isEditable && !this.hideControl3) {
        return '登録情報'
      }
      return ''
    },
  },
  watch: {
    keyword() {
      this.fetchItems(0)
    },
  },
  mounted() {
  },
  methods: {
    onIntersect() {
      this.fetchItems()
      this.fetchFeaturingPrefixes()
    },
    async fetchItems(page) {
      this.loading = true
      this.pagination = { data: [] }
      const headers = { 'content-type': 'multipart/form-data', 'X-CMAP-No-Loading': true }
      const { data } = await window.axios.get('/api/client/products', {
        params: {
          count: this.count,
          release_status: this.releaseStatus,
          page,
          keyword: this.keyword,
        },
        headers,
      })
      this.pagination = data
      Object.keys(data.meta).forEach(key => {
        this.pagination[key] = data.meta[key]
      })
      Object.keys(data.links).forEach(key => {
        this.pagination[`${key}_page_url`] = data.links[key]
      })
      this.loading = false
    },
    async fetchFeaturingPrefixes() {
      const headers = { 'content-type': 'multipart/form-data', 'X-CMAP-No-Loading': true }
      const { data } = await window.axios.get('/api/client/code/featuring-prefixes', { headers })
      this.featuringPrefixes = data
    },
    onPaginationClicked(page) {
      this.fetchItems(page)
      this.$emit('on-pagination-clicked', page)
    },
    anyTitle(item) {
      const title = item.title || (item.titles.length > 0 ? item.titles[0].title : '')
      let version = item.versions.length ? `${item.versions[0].version}` : ''
      let featuring = ''
      const firstTrack = item.tracks[0] ?? {}
      if (item.type === 'single'
        && Object.prototype.hasOwnProperty.call(firstTrack, 'meta_artists')
        && firstTrack.meta_artists) {
        const featuringArtists = []
        let prefix = ''
        firstTrack.meta_artists.featuring_artists.forEach((artist, index) => {
          featuringArtists.push(artist.name_ja)
          if (index === 0) prefix = this.featuringPrefixes[artist.prefix]
        })
        if (featuringArtists.length) featuring = `\n${prefix} ${featuringArtists.join(',')}`
      }
      if (version.length) version = `(${version})`
      return `${title}${featuring}${version.length ? '\n' : ''}${version}`
    },
    getMainArtists(item) {
      if (item.artists[0] && item.artists[0].type === 2) {
        // Various Artists
        return item.artists[0].name
      }
      if (item.type === 'single' && item.tracks.length > 0 && item.tracks[0].meta_artists) {
        const artistNames = item.tracks[0].meta_artists.main_artists.map(a => {
          if (item.status === 0) {
            return a.name_ja
          }
          return a.pivot?.name ?? a.name_ja
        })
        return window._.uniq(artistNames).join(' / ')
      }
      // タイトルのフィーチャリングアーティストはメインアーティストとして表示しない
      const mainArtists = (item.artists || []).filter(a => a.pivot?.role !== 'featured artist')
      if (mainArtists.length === 0) {
        return item.artist_name
      }
      const artistNames = mainArtists.map(a => {
        if (item.status === 0) {
          return a.name_ja
        }
        return a.pivot?.name ?? a.name_ja
      })
      return window._.uniq(artistNames).join(' / ')
    },
  },
}
</script>

<style scoped>
.empty-cell {
  text-align: center;
  color: #505050;
  padding-top: 5vmin;
  padding-bottom: 5vmin;
}
.wrap-text {
  white-space: pre-line;
  word-break: break-all;
}
@media screen and (max-width: 895px) {
  .my-release-list__cell-title {
    width: calc(64vw + 44px);
    min-width: calc(64vw + 44px);
    max-width: calc(64vw + 44px);
  }
  .wrap-text {
    width: calc(64vw + 44px);
    min-width: calc(64vw + 44px);
    max-width: calc(64vw + 44px);
    white-space: pre-line;
    word-break: break-all;
  }
}
.vld-overlay {
  position: relative!important;
}
.vld-cell {
  display: flex;
  justify-content: center;
}
.vld-loading-icon {
  display:inline-flex;
}
.vld-text {
  display:inline-flex;
  padding-left: 10px;
}
.disabled-cell {
  background-color: #F9F6F6;
}

</style>
